import { RootReducer } from '../rootReducer';

export const selectMealPlan = (state: RootReducer) => state.nutrition.plan;
export const selectIsLoading = (state: RootReducer) => state.nutrition.isLoading;
export const selectMeal = (state: RootReducer) => state.nutrition.meal;
